import {Component, Input, OnInit} from '@angular/core';
import {OutgoingSms} from "../../../../../lib/sms/outgoing/task-record-outgoing-sms.service";
import {SmsTemplate} from "../../../../../lib/sms/sms-template/sms-template.service";

@Component({
  selector: 'app-outgoing-sms-info',
  templateUrl: './outgoing-sms-info.component.html',
  styleUrls: ['./outgoing-sms-info.component.scss']
})
export class OutgoingSmsInfoComponent implements OnInit {

  @Input()
  sms: OutgoingSms.OutgoingSms;

  constructor() { }

  ngOnInit(): void {
  }

  getSmsStateKey(state?: OutgoingSms.SmsState): string {
    if (!state) {
      return '';
    }
    return OutgoingSms.smsStates.find(s => s.state === state)!.stringKey;
  }

  getSmsStateClass(state?: OutgoingSms.SmsState): string {
    if (!state) {
      return '';
    }
    switch (state) {
      case OutgoingSms.SmsState.WAITING:
        return 'sms-icon-waiting';
      case OutgoingSms.SmsState.REQUEST_SENT:
        return 'sms-icon-request-sent';
      case OutgoingSms.SmsState.SUCCESSFUL_DELIVERY:
        return 'sms-icon-successful';
      case OutgoingSms.SmsState.REQUEST_FAILED:
        return 'sms-icon-failed';
      case OutgoingSms.SmsState.FAILED_DELIVERY:
        return 'sms-icon-failed';
    }
  }

  getSmsSendModeKey(sendMode?: OutgoingSms.SmsSendMode): string {
    if (!sendMode) {
      return '';
    }
    return OutgoingSms.smsSendModes.find(s => s.sendMode === sendMode)!.stringKey;
  }

  getSmsIntegrationTypeKey(integrationType?: SmsTemplate.SmsIntegrationType): string {
    if (!integrationType) {
      return '';
    }
    return SmsTemplate.integrationTypes.find(s => s.id === integrationType)!.itemName;
  }

}
